// apps/frontend/src/config/api.ts
// Point unique de vérité pour l'URL de base de l'API

export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3001'
